module.exports = __webpack_public_path__ + "media/images/ui__themeToggleDark-dac767654d0b73165f3b878a83b25e85.png";